// Operator gate. Wraps the /admin/* routes so non-operators are silently
// bounced to "/". The sidebar already hides the Platform group for non-
// operators; this is defense-in-depth for a direct URL paste.
//
// Note: the BFF independently 403s every /platform/* call for non-operators.
// This component is UX only — the server is the source of truth.

import { Navigate } from "react-router-dom";
import { type ReactNode } from "react";
import { useAuth } from "./AuthContext";

export function OperatorGate({ children }: { children: ReactNode }) {
  const { status, user } = useAuth();
  if (status === "loading") {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          background: "var(--bg)",
          color: "var(--fg-muted)",
          fontFamily: "var(--font-mono)",
          fontSize: 12,
          letterSpacing: "0.02em",
        }}
      >
        loading…
      </div>
    );
  }
  if (!user?.isOperator) return <Navigate to="/" replace />;
  return <>{children}</>;
}
